import { VideoGameRatingDto } from 'types/dtos'
import { VideoGameRatingModel } from 'types/models'

export const transformVideoGameRatingDto = (
  videoGameRating: VideoGameRatingDto,
): VideoGameRatingModel => {
  const { id, title } = videoGameRating

  return {
    id,
    title,
  }
}

export const transformVideoGameRatingDtos = (
  videoGameRatings: Array<VideoGameRatingDto>,
): Array<VideoGameRatingModel> => videoGameRatings.map(transformVideoGameRatingDto)
